import React, {Component} from 'react';
import {Modal, Button, Tooltip} from 'antd';
import IconTemperature from '../style/icon/IconTemperature'
import IconHumidity from '../style/icon/IconHumidity'
import IconACMeter from '../style/icon/IconACMeter'
import IconPowerDayMeter from '../style/icon/IconPowerDayMeter'
import IconPowerMonthMeter from '../style/icon/IconPowerMonthMeter'
import IconPowerCurrentMeter from '../style/icon/IconPowerCurrentMeter'
import IconPowerMeter from '../style/icon/IconPowerMeter'
import IconShine from '../style/icon/IconShine'
import IconWarning from '../style/icon/IconWarning'

import {
  SUB_CATEGORY_TEMPERATURE,
  SUB_CATEGORY_HUMIDITY,
  SUB_CATEGORY_V_AC_METER,
  SUB_CATEGORY_LUMINARY,
  SUB_CATEGORY_TEMPERATURE_OUTSIDE,
  SUB_CATEGORY_HUMIDITY_OUTSIDE,
  SUB_CATEGORY_POWER_METER,
  SUB_CATEGORY_POWER_METER_DAY,
  SUB_CATEGORY_POWER_METER_MONTH,
  SUB_CATEGORY_POWER_METER_COUNTER,
  DEVICE_STATUS_COLOR_ON
} from '../constants/defaultValues'
import {timeAgoVnShortFromEpochTime} from '../utils'

class ModalDeviceAIN extends Component {
  displayDevice(dev) {
    switch (dev.SubCategory) {
      case SUB_CATEGORY_TEMPERATURE:
      case SUB_CATEGORY_TEMPERATURE_OUTSIDE:
        return <IconTemperature color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_HUMIDITY:
      case SUB_CATEGORY_HUMIDITY_OUTSIDE:
        return <IconHumidity color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_V_AC_METER:
        return <IconACMeter color={dev.Color} size="lg"/>
      case SUB_CATEGORY_POWER_METER:
        return <IconPowerCurrentMeter color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_POWER_METER_DAY:
        return <IconPowerDayMeter color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_POWER_METER_MONTH:
        return <IconPowerMonthMeter color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_POWER_METER_COUNTER:
        return <IconPowerMeter color={dev.Color
} size="lg"/>
      case SUB_CATEGORY_LUMINARY:
        return <IconShine color={dev.Color
} size="lg"/>
      default:
        return <span>{dev.Name}</span>
    }
  }

  handleLineChartClick = (dev) => {
    this.props.onLineChartClick(dev)
  }

  render() {
    const {visible, onCancel, device, sending} = this.props

    const icon = this.displayDevice(device)
    const roomName = device.RoomName && device.RoomName !== "Default"
      ? device.RoomName.toLowerCase()
      : ""
    const deviceName = device && device.Name !== ""
      ? device.Name
      : ""
    const title = `${deviceName} ${roomName}`
    const disconnected = device.Disconnected
    const {time, inHours} = timeAgoVnShortFromEpochTime(device.Time)
    const timeColor = inHours === true
      ? {
        color: DEVICE_STATUS_COLOR_ON
      }
      : null
    return (<Modal visible={visible} title={title} onCancel={onCancel} footer={[<Button key="cancel" onClick={onCancel}>Bỏ qua</Button>
        ]}>
      <div className="form-device-relay">
        <div className="box-device">
          <div>
            <span className="text" style={{
                color: device.Color
              }}>{device.Text}</span>
            <span className="time" style={timeColor}>{time}</span>
          </div>
          {
            device.SubCategory !== SUB_CATEGORY_POWER_METER_COUNTER
              ? <span className="line-chart">
                  <Tooltip placement="left" title="Biểu đồ dữ liệu">
                    <Button type="primary" ghost={true} shape="circle" icon="line-chart" onClick={() => this.handleLineChartClick(device)}></Button>
                  </Tooltip>
                </span>
              : null
          }
          {icon}
          {
            device.Disconnected
              ? <div className="value">
                  <span className="disconnected"><IconWarning/></span>
                </div>
              : <div className="value">
                  <span className="number" style={{
                      color: device.Color
                    }}>{Math.round(device.Val / 10)}</span>
                  <span className="unit">{device.Unit}</span>
                </div>
          }
        </div>
      </div>
    </Modal>);
  }
}
export default ModalDeviceAIN;



// WEBPACK FOOTER //
// ./src/components/ModalDeviceAIN.js